import React from 'react';
import { StylovyzeDialog } from '@innovyze/stylovyze';
import { StyledWarningDialogPaper } from './ValuemappingOverridesWarningDialog.styles';
import { Typography } from '@mui/material';

interface ValuemappingOverridesWarningDialogProps {
	open: boolean;
	messages: string[];
	onConfirm: () => void;
	onCancel: () => void;
	confirmButtonDisabled: boolean;
}

export const ValuemappingOverridesWarningDialog: React.FC<
	ValuemappingOverridesWarningDialogProps
> = (props: ValuemappingOverridesWarningDialogProps) => {
	const { open, messages, onConfirm, onCancel, confirmButtonDisabled } =
		props;

	return (
		<StylovyzeDialog
			title="Override profile value"
			open={open}
			confirmText="Apply Profile"
			cancelText="Cancel"
			onConfirm={onConfirm}
			onCancel={onCancel}
			confirmButtonProps={{ disabled: confirmButtonDisabled }}>
			<StyledWarningDialogPaper>
				<Typography>
					This profile will override the value for sensors:
				</Typography>
				{messages.map((msg, idx) => (
					<Typography key={idx}>{msg}</Typography>
				))}
				<Typography>
					Do you want to continue with this action?
				</Typography>
			</StyledWarningDialogPaper>
		</StylovyzeDialog>
	);
};

export default ValuemappingOverridesWarningDialog;
